import { post } from '../index';

export const postLicence = data => {
  return post('/licenses', data);
};
